"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBox = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)((0, translation_1.getLocalization)('notFound')), recompose_1.pure);
exports.CardBox = enhance(function (props) { return (React.createElement("div", { className: classNames("card-box card-box-wrapper-".concat(props.title), props.className) },
    React.createElement(sok_ui_1.AccordionPanel, { title: (0, translation_1.getLocalization)("diaryEntryView/accordion/".concat(props.title)), toggled: props.toggled },
        React.createElement("div", { className: "card-box-content card-box-".concat(props.title) }, props.children)))); });
